<div class="wrapper">
    <app-header class="header"></app-header>
    <main class="main">
        <router-outlet> </router-outlet>
    </main>
    <app-footer></app-footer>
</div>